module.exports = __webpack_public_path__ + "img/logo.a0a9330b.svg";